import {FormControl, InputLabel, Select} from "@mui/material";
import React from "react";
import {FORM_VALUE_UPDATED, useFormDispatch, useFormState} from "./formContext";
import {useFieldValidation} from "./useFieldValidation";
import {useIsFieldRequired} from "./useIsFieldRequired";


export const SelectForm = ({formKey, label, disabled=false, children}) => {
    const {
        formData,
        errors,
        isSubmitting,
    } = useFormState();
    const [touched, setTouched] = React.useState(false);

    const dispatch = useFormDispatch();
    useFieldValidation(formKey);
    const required = useIsFieldRequired(formKey);

    const changeHandler = event => {
        setTouched(true);
        dispatch({
            type: FORM_VALUE_UPDATED,
            key: formKey,
            value: event.target.value
        });
    };

    const hasError = (touched || isSubmitting) && Boolean(errors[formKey]);

    return (
        <FormControl
            required={required}
            disabled={disabled}
            error={hasError}
        >
            <InputLabel id={`${formKey}-label`}>
                {label}
            </InputLabel>
            <Select
                id={formKey}
                labelId={`${formKey}-label`}
                name={label}
                label={label}
                error={hasError}
                value={formData[formKey] ?? ""}
                onChange={changeHandler}
                onBlur={() => setTouched(true)}
            >
                {children}
            </Select>
        </FormControl>
    );
};